const SignatureModes = {
  FULL_SIGNATURE: window.Tools.SignatureCreateTool.SignatureTypes.FULL_SIGNATURE,
  INITIALS: window.Tools.SignatureCreateTool.SignatureTypes.INITIALS,
};

export default SignatureModes;